
import { supabase } from '@/integrations/supabase/client';

export const getHealthPoints = async (profileId: string): Promise<number> => {
  try {
    if (!profileId) return 0;
    
    const { data, error } = await supabase
      .from('health_points')
      .select('total_points')
      .eq('profile_id', profileId)
      .maybeSingle();
      
    if (error) throw error;
    return data?.total_points || 0;
  } catch (error) {
    console.error('Error al obtener puntos de salud:', error);
    return 0;
  }
};
